export const isPrintable = (key: string) => {
    if (key === null) return false;

    // currently this solution is equivalent to previous solution :
    // https://github.com/LogicSoftware/EPFrontend/blob/d237ee2958c0bb5bf5491174879a3af9f47d6e12/src/Scripts/EasyProjectsCommon/General.js#L53
    // but some printable emojees and some other characters may be 2 byte length
    // and it would be better in the future to enlarge enum Keys to contain all keyboard non-printable codes and check key by not in Keys
    if (key.length === 1 || key === "Unidentified") {
        return true;
    }

    return false;
};

export const isNumber = (key: string) => {
    if (key === null) return false;

    const intValue = parseInt(key, 10);
    if (isNaN(intValue)) {
        return false;
    }

    return true;
};
